/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListResponse } from '../models/ListResponse';
import type { SpeamboxMqttTopic } from '../models/SpeamboxMqttTopic';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SpeamboxMqttTopicService {

    /**
     * Get a list of `SpeamboxMqttTopic`s
     * @returns any A list of `SpeamboxMqttTopic`s.
     * @throws ApiError
     */
    public static listSpeamboxMqttTopics({
page,
size,
filter,
sort,
searchTerm,
}: {
/**
 * Page number
 */
page?: number,
/**
 * Number of items per page
 */
size?: number,
/**
 * A filter to apply to the results. Multiple filters can be applied by using the same parameter name multiple times. String must be URL encoded. String follows the format field,operator,value(s),required. Filters can be applied to associations by using `[associatedModel*].[attribute]` as field. If values is an array, which is allowed for e.g. the operators "in", "notIn" etc, the delimiter "|" must be used. "required" is allowed, if a deep filter (= filter on an association) is set. In this case, only entities that have an associated entity are returned. *model name should be written as in the API Response, meaning with lowercase first letter and if need be in plural. `required` is optional
 */
filter?: string,
/**
 * Sorts the results by the given field and order. The format is field:order. The order can be asc or desc. Multiple fields can be sorted by using a comma separated list.
 */
sort?: string,
/**
 * Seach Term for full text search. Whether supported and which fields are included depends on the model.
 */
searchTerm?: string,
}): CancelablePromise<(ListResponse & {
data?: Array<SpeamboxMqttTopic>;
})> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/speambox-mqtt-topics',
            query: {
                'page': page,
                'size': size,
                'filter': filter,
                'sort': sort,
                'searchTerm': searchTerm,
            },
        });
    }

    /**
     * Create a new `SpeamboxMqttTopic`
     * @returns SpeamboxMqttTopic A single `SpeamboxMqttTopic`.
     * @throws ApiError
     */
    public static createSpeamboxMqttTopic({
requestBody,
}: {
requestBody: SpeamboxMqttTopic,
}): CancelablePromise<SpeamboxMqttTopic> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/speambox-mqtt-topics',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get a specific `SpeamboxMqttTopic`
     * @returns SpeamboxMqttTopic A single `SpeamboxMqttTopic`.
     * @throws ApiError
     */
    public static getSpeamboxMqttTopic({
id,
}: {
/**
 * ID of the `SpeamboxMqttTopic`
 */
id: string,
}): CancelablePromise<SpeamboxMqttTopic> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/speambox-mqtt-topics/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Update a specific `SpeamboxMqttTopic`
     * @returns SpeamboxMqttTopic A single `SpeamboxMqttTopic`.
     * @throws ApiError
     */
    public static updateSpeamboxMqttTopic({
id,
requestBody,
}: {
/**
 * ID of the `SpeamboxMqttTopic`
 */
id: string,
requestBody: SpeamboxMqttTopic,
}): CancelablePromise<SpeamboxMqttTopic> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/speambox-mqtt-topics/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete a specific `SpeamboxMqttTopic`
     * @returns void 
     * @throws ApiError
     */
    public static deleteSpeamboxMqttTopic({
id,
}: {
/**
 * ID of the `SpeamboxMqttTopic`
 */
id: string,
}): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/speambox-mqtt-topics/{id}',
            path: {
                'id': id,
            },
        });
    }

}
